var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.001C1 14.9184 2.15893 17.7163 4.22183 19.7792C6.28473 21.8421 9.08262 23.001 12 23.001C14.9174 23.001 17.7153 21.8421 19.7782 19.7792C21.8411 17.7163 23 14.9184 23 12.001C23 9.08363 21.8411 6.28573 19.7782 4.22283C17.7153 2.15993 14.9174 1.00101 12 1.00101C9.08262 1.00101 6.28473 2.15993 4.22183 4.22283C2.15893 6.28573 1 9.08363 1 12.001V12.001Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.005H13C12.7348 17.005 12.4804 16.8996 12.2929 16.7121C12.1054 16.5246 12 16.2702 12 16.005V9.505C12 9.3724 11.9473 9.24522 11.8536 9.15145C11.7598 9.05768 11.6326 9.005 11.5 9.005H10",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.745 6.5C11.6955 6.5 11.6472 6.51466 11.6061 6.54213C11.565 6.5696 11.5329 6.60865 11.514 6.65433C11.4951 6.70001 11.4902 6.75028 11.4998 6.79877C11.5094 6.84727 11.5333 6.89181 11.5682 6.92678C11.6032 6.96174 11.6477 6.98555 11.6962 6.9952C11.7447 7.00484 11.795 6.99989 11.8407 6.98097C11.8863 6.96205 11.9254 6.93 11.9529 6.88889C11.9803 6.84778 11.995 6.79945 11.995 6.75C11.995 6.6837 11.9687 6.62011 11.9218 6.57322C11.8749 6.52634 11.8113 6.5 11.745 6.5Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRound);
export default __webpack_public_path__ + "static/media/info-round.74f6afaa37d60ca701c5757c236910d2.svg";
export { ForwardRef as ReactComponent };